import { Component, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OAuthEvent, OAuthInfoEvent, OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';
import { UserAccountDto } from './services/api-client/models';
import { UserAccountRestControllerService } from './services/api-client/services';
import { UserStoreService } from './services/user-store.service';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { ParseCvService } from './shared/services/parse-cv.service';
import { MatDrawer } from '@angular/material/sidenav';
import { CreateCvService } from './shared/services/create-cv.service';
import { Subscription } from 'rxjs';
import { ScrollService } from './shared/services/scroll.service';
import { ThemeService } from './theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'greybee Skill Management Portal';
  openUpload = false;
  openCreate = false;
  subs = new Subscription();
  @ViewChild('drawer') sidebar: MatDrawer;
  constructor(
    private translate: TranslateService,
    private oauthService: OAuthService,
    private userStore: UserStoreService,
    private userAccountService: UserAccountRestControllerService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private parseCvService: ParseCvService,
    private createCvService: CreateCvService,
    private scrollService: ScrollService,
    private themeService: ThemeService,
  ) {
    this.themeService.loadTheme();

    this.registerIcons();
    //translate.use(environment.cvLanguage);
    translate.setDefaultLang('de');

    this.oauthService.configure(authConfig);
    this.subs.add(this.oauthService.events.subscribe((event: OAuthEvent) => {
      if(event instanceof OAuthInfoEvent || event instanceof OAuthSuccessEvent) {
        if(event.info) console.log(event.info);
      }
    }));
    this.oauthService.loadDiscoveryDocumentAndLogin().then((loggedIn: boolean) => {
      // this.oauthService.loadUserProfile().then((info: UserInfo) => console.log(info));
      this.subs.add(this.userAccountService.getCurrentUser().subscribe((user: UserAccountDto) => {
        this.userStore.storeUser(user);
      }));
    });
    this.oauthService.setupAutomaticSilentRefresh();
    this.subs.add(this.parseCvService.openSidebar.subscribe(isOpen => {
      isOpen ? this.sidebar.open() : this.sidebar.close();
      this.openCreate = false;
      this.openUpload = isOpen;
    }));
    this.subs.add(this.createCvService.openSidebar.subscribe(isOpen => {
      isOpen ? this.sidebar.open() : this.sidebar.close();
      this.openUpload = false;
      this.openCreate = isOpen;
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private registerIcons () {
    this.matIconRegistry.addSvgIcon('search', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/search.svg"));
    this.matIconRegistry.addSvgIcon('list', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/list.svg"));
    this.matIconRegistry.addSvgIcon('pencil', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/pencil.svg"));
    this.matIconRegistry.addSvgIcon('plus', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/plus.svg"));
    this.matIconRegistry.addSvgIcon('trash', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/trash.svg"));
    this.matIconRegistry.addSvgIcon('upload', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/upload.svg"));
    this.matIconRegistry.addSvgIcon('user', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/user.svg"));
    this.matIconRegistry.addSvgIcon('sort-up', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/sort-up.svg"));
    this.matIconRegistry.addSvgIcon('sort-down', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/sort-down.svg"));
    this.matIconRegistry.addSvgIcon('eye', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/eye.svg"));
    this.matIconRegistry.addSvgIcon('eye-slash', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/eye-slash.svg"));
    this.matIconRegistry.addSvgIcon('times-circle', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/times-circle.svg"));
    this.matIconRegistry.addSvgIcon('info-circle', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/info-circle.svg"));
    //new icons
    this.matIconRegistry.addSvgIcon('download', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/download.svg"));
    this.matIconRegistry.addSvgIcon('remove', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/remove.svg"));
    this.matIconRegistry.addSvgIcon('account_box', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/account_box.svg"));
    this.matIconRegistry.addSvgIcon('add_photo_alternate', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/add_photo_alternate.svg"));
    this.matIconRegistry.addSvgIcon('add', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/add.svg"));
    this.matIconRegistry.addSvgIcon('calendar_month', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/calendar_month.svg"));
    this.matIconRegistry.addSvgIcon('check', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/check.svg"));
    this.matIconRegistry.addSvgIcon('clinical_notes', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/clinical_notes.svg"));
    this.matIconRegistry.addSvgIcon('close', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/close.svg"));
    this.matIconRegistry.addSvgIcon('delete', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/delete.svg"));
    this.matIconRegistry.addSvgIcon('drag_handle', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/drag_handle.svg"));
    this.matIconRegistry.addSvgIcon('edit', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/edit.svg"));
    this.matIconRegistry.addSvgIcon('expand_less', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/expand_less.svg"));
    this.matIconRegistry.addSvgIcon('expand_more', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/expand_more.svg"));
    this.matIconRegistry.addSvgIcon('format_list_bulleted', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/format_list_bulleted.svg"));
    this.matIconRegistry.addSvgIcon('library_books', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/library_books.svg"));
    this.matIconRegistry.addSvgIcon('logout', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/logout.svg"));
    this.matIconRegistry.addSvgIcon('person_search', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/person_search.svg"));
    this.matIconRegistry.addSvgIcon('visibility_off', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/visibility_off.svg"));
    this.matIconRegistry.addSvgIcon('visibility', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/visibility.svg"));
    this.matIconRegistry.addSvgIcon('arrow_back', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/arrow_back.svg"));
    this.matIconRegistry.addSvgIcon('arrow_upward', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/arrow_upward.svg"));
    this.matIconRegistry.addSvgIcon('arrow_downward', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/arrow_downward.svg"));
    this.matIconRegistry.addSvgIcon('sort', this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icons/sort.svg"));
  }

  onScrolledWrapper($event) {
    this.scrollService.onScrolledEvent.next($event);
  }
}
